const styles = {
  container: {
    marginY: { xs: 0, md: 7 },
    paddingTop: { xs: 2, md: 0 },
    paddingX: 2,
  },
  imageSwiper: {
    '& .swiper': {
      width: '100%',
      height: {
        xs: 300, md: 250, lg: 364, xl: 364,
      },
    },
    pl: { xs: 0, sm: 0.5 },
    pr: { xs: 0, sm: 0.5 },
    mb: { xs: 4, md: 0.5 },
  },

  title: {
    mb: 2,
  },
  childrenContainer: {
    '& .MuiBox-root': {
      margin: '0 auto',
    },
  },
  itemsContainer: {
    mt: { xs: 0, md: 1 },
  },

}
export default styles
